import { updatePricingVehicleRequest } from "../../data/pricingVehicleApi";
import { validatePricingVehiclePayload } from "../validator/validatePricingVehiclePayload";

export async function updatePricingVehicleUseCase(payload) {
  const error = validatePricingVehiclePayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await updatePricingVehicleRequest(payload);
}
